/**
 * The app can be served under a base path (Vite `base`), for example `/my-account` behind the
 * composition shell. React Router handles the base path for `<Link>`, `navigate` and
 * `useLocation`. Use these helpers only for URLs outside the router, including
 * `window.location`, `window.open`, and code outside `BrowserRouter`.
 */

/** The base path without a trailing slash. It is empty at the root. */
export const getBasePath = () => import.meta.env.BASE_URL.replace(/\/$/, '');

/** Adds the base path to an app path, for example `/messages`. */
export const withBasePath = (path: string) => `${getBasePath()}${path}`;

/** Removes the base path from a browser path, so it can be matched against app routes. */
export const stripBasePath = (pathname: string) => {
  const basePath = getBasePath();
  if (!basePath) return pathname;
  if (pathname === basePath) return '/';
  return pathname.startsWith(`${basePath}/`) ? pathname.slice(basePath.length) : pathname;
};
